export const eVisitOverviewScreen = {
  screenTitle: 'E-Visit Overview',
  howItWorksItems: [
    {
      key: 'hiw01',
      importantText: 'Click on Start an E-Visit',
      regularText: 'to share your symptoms with a provider.'
    },
    { key: 'hiw02', importantText: 'Provider reviews and creates a plan', regularText: '' },
    {
      key: 'hiw03',
      importantText: 'Treatment plan is sent to you',
      regularText: '(Response in 1 to 2 hours*)'
    },
    {
      key: 'hiw04',
      importantText: '',
      regularText:
        'Treatment plan typically includes a diagnosis and next steps. Prescriptions are sent to the pharmacy of your choice (if applicable) are sent to the pharmacy of your choice. Your insurance will be billed for this visit. Please check with your insurance company for the details.**'
    },
    {
      key: 'hiw05',
      importantText: '',
      regularText:
        'E-Visits are currently being tested with a limited number of our patients. We appreciate your willingness to help with the development of this new method of delivering care. We will bill your insurance for this visit. If the provider determines they can’t treat you via an E-visit and refer you elsewhere, there will be no charge for this E-Visit.  Please check with your insurance company for details.'
    },
    {
      key: 'hiw06',
      importantText: '',
      regularText:
        'At this time only COVID-19 testing can be ordered via E-Visits. Other tests, such as a rapid strep test, cannot be ordered through E-Visits.'
    },
    {
      key: 'hiw07',
      importantText: '',
      regularText: [
        {
          type: 'text',
          value:
            'Intermountain practices antibiotic stewardship which may limit antibiotics for certain conditions.  This protects patients from harm caused by unnecessary antibiotics and combats antibiotic resistance. Please click'
        },
        {
          type: 'link',
          value: ' here ',
          link: 'https://intermountainhealthcare.org/ckr-ext/Dcmnt?ncid=529408301'
        },
        { type: 'text', value: 'for more information' }
      ]
    }
  ],
  sectionTitle: {
    howItWorks: 'How it works',
    pricing: 'Pricing',
    conditions: 'Conditions treated with E-Visits'
  },
  button: {
    startEVisit: 'Start an E-Visit'
  },
  card: {
    title: 'Your out of pocket cost today',
    disclosure: 'Pricing based on your insurance coverage and may vary.'
  },
  treatedConditions: [
    'Common Cold',
    'Sinus Infection',
    'Seasonal Alllergies',
    'Sore Throat',
    'Flu',
    'COVID-19 Coronavirus',
    'Asthma',
    'Headache',
    'Pink Eye',
    'Sty',
    'Acid Reflux and Heartburn',
    'Stomach Virus/Stomach Flu',
    'Hemorrhoids',
    'urinary Tract Infection/UTI',
    'Bladder Infection',
    'Vaginal Yeast Infection',
    'New Low Back Pain'
  ],
  disclosureItems: [
    {
      key: 'dis01',
      content: 'Estimations based on normal daytime hours and may vary at night.',
      withAsterisk: true
    },
    {
      key: 'dis02',
      content:
        '(If you can not be treated with an E-Visit, you will be directed to another care option and will not be charged).',
      withAsterisk: false
    }
  ]
};

export const eVisitStateLocationConstants = {
  screenTitle: 'E-Visit',
  title: "Where it's available",
  headerText: 'E-Visits are only available in Utah, Idaho and Nevada at this time.',
  notInUtah: 'Not in this area?',
  consentCheckbox: 'I have read and agree to the MyHealth+',
  consentCheckboxLink: 'Consent and Conditions of Service',
  noticeCheckbox: 'I acknowledge I have been offered the',
  noticeCheckboxLink: 'Intermountain Healthcare Notice of Privacy Practices',
  termsOfUseCheckbox: 'I have read and agree to the E-Visit',
  termsOfUseCheckboxLink: 'Terms of Use'
};

export const eVisitNotInUtahDialogConstants = {
  dialogTitleText:
    'Unfortunately, E-Visits are only available in Utah, Nevada and Idaho at this time.',
  dialogContentText: 'Check back at a later date for your location availability.',
  dialogButtonText: 'Go back to Care Options'
};

export const EVISIT_CONFIRM_DIALOG_TEXT = {
  title: 'Are you sure you want to cancel this E-Visit?',
  subtitle: 'Your information will be lost.',
  primaryButton: 'Yes, cancel my E-Visit',
  secondaryButton: 'No, take me back'
};

export const EVISIT_STATES = [
  { label: 'Idaho', value: 'ID' },
  { label: 'Nevada', value: 'NV' },
  { label: 'Utah', value: 'UT' }
];

export const COVID19_CHECKER_CARD = {
  url: 'https://intermountainhealthcare.org/health-wellness-promotion/pandemics/covid/get-testing/'
};

export const COVID_GET_TESTING_INFO = {
  url: 'https://intermountainhealthcare.org/health-wellness-promotion/pandemics/covid/get-testing/'
};

export const COVID_VACCINE_INFO = {
  url: 'https://intermountainhealthcare.org/Health-Wellness-Promotion/Vaccines/COVID'
};
